import styled from "styled-components";

export const OrderSubTabSection = styled.div`
  display: flex;
`;
